export default __webpack_public_path__ + "static/media/PalotoaTeparo.a518d5a8.jpg";